module.exports = "data:image/gif;base64,R0lGODlhAQBYAoABAKaJTP///yH+EUNyZWF0ZWQgd2l0aCBHSU1QACH5BAEKAAEALAAAAAABAFgCAAIXjI+py+0Po5y02ouz3rz7D4biSJZmUgAAOw=="